import { RunInstanceLogEntityModel } from "src/store/models/entity/runinstanceLog/entity";
import { RunInstanceLogListModel } from "src/store/models/entity/runinstanceLog/list";

export const encooRunInstanceLogModels = {
  entity: RunInstanceLogEntityModel,
  // helper: RunInstanceLogHelperModel,
  list: RunInstanceLogListModel,
};
